import api from "../api/api";
import { practiceFeatures } from "../config/practice";

/*
 * The MedTrack board's data (rooms' occupants, waiting room, tele-health).
 *
 * 9928: GET v1 /medtrack/get (one row per patient; ?departmentid= for a
 *       per-department board), exactly as before.
 * 7825 (practiceFeatures().osaBoard): GET v1 /medtrack/fetch, the route OSA's
 *       own board polls -- the same rows without the per-patient grouping (so
 *       a shared room returns every occupant), plus `payInCash`, and served
 *       from a 4-second per-practice cache. It exists on v1 only, so it is
 *       pinned to v1 (`_gw`, see api/api.js); it takes no department filter.
 *
 * `config` is the board's existing request config, passed through unchanged.
 */
export const getMedtrackBoard = (practiseid, deptQS, config) =>
  practiceFeatures().osaBoard
    ? api.get(`/v1/${practiseid}/medtrack/fetch`, { ...config, _gw: "v1" })
    : api.get(`/v1/${practiseid}/medtrack/get${deptQS}`, config);

// Today's visits in `roomName` (room_no trimmed), one per patient (a patient
// can have more than one visit row), in the order the server sent them.
export const roomOccupants = (rows, roomName) => {
  const inRoom = (rows || []).filter(
    (apt) => apt.room_no !== null && apt.room_no !== undefined && apt.room_no !== "" &&
      String(apt.room_no).trim() === roomName
  );
  return inRoom.filter(
    (a, i) => inRoom.findIndex((b) => String(b.patientid) === String(a.patientid)) === i
  );
};

// "Last, F" as the board abbreviates a name (care's tiles: 3 letters of the
// surname; a board profile's surnameLetters -- OSA: 4 -- when passed).
export const boardName = (p, surnameLetters = 3) =>
  `${p?.lastname?.substring(0, surnameLetters) || ""}, ${p?.firstname?.charAt(0) || ""}`;

// Visits in one status list (profile.medtrack.statusPanels): rows of `data`
// whose visit_confirmation is exactly `status`.
export const statusPanelRows = (rows, status) =>
  (rows || []).filter((apt) => apt.visit_confirmation === status);

// The Pay-in-Cash list. v1 medtrack/fetch names it `payInCash`; OSA's build
// also accepted the other spellings, kept here for a server that sends them.
export const payInCashRows = (data) => {
  const raw = data?.payInCash ?? data?.payincash ?? data?.pay_in_cash ?? data?.payIncash;
  return Array.isArray(raw) ? raw : [];
};
